import React from "react";
import { useNavigate } from "react-router-dom";
import { YellowButton } from "../components/Buttons";

// Component
import MainView from "../components/MainView";

// Assets
import mouseImg from "../assets/core/img/mouse.png";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <MainView screen navbar={false} logo={false}>
      <div className="px-[5vw] 2xl:px-[15vw] h-full">
        <div className="h-full w-full flex flex-col sm:flex-row items-center justify-center gap-5">
          <div className="w-[80%] sm:w-[25%]">
            <img src={mouseImg} alt="" />
          </div>

          <div className="flex flex-col items-center justify-center sm:items-start">
            <p className="font-bold font-retro-sabo text-black text-6xl sm:text-7xl text-center">
              404
            </p>

            <p className="font-retro-rounded text-xl text-center mb-4">
              Our mouse ate this page....
            </p>

            <div className="w-[70vw] sm:w-56 xl:w-80 2xl:w-96">
              <YellowButton
                onClick={() => {
                  navigate("/games", { replace: true });
                }}
              >
                Take Me Back
              </YellowButton>
            </div>
          </div>
        </div>
      </div>
    </MainView>
  );
}
